import { EXPIRATION_LEAD_TIME_SECONDS } from "../auth/userServices";
import { useAppSelector } from "../store/hooks";
import { authResultGetCnamCustomerId } from "../utils/authUtils";
import { useIsAdminUser } from "./useIsAdminUser";
import { useIsUserAuthenticated } from "./useIsUserAuthenticated";

export const useIsCNAMPortalUser = () => {
  const hasCnamCustomerIdSet: boolean = useAppSelector(
    (state) => state.auth.cnamCustomerId !== ""
  );
  const isUserAuthenticated = useIsUserAuthenticated();
  const isAdmin = useIsAdminUser();

  // Make sure this env even has a CNAM portal enabled...
  const envCnamPortalEnabled =
    process.env.REACT_APP_CNAM_BASE_URL !== undefined;

  return (includeAdmin: boolean = true): boolean => {
    return (
      (isUserAuthenticated() && hasCnamCustomerIdSet && envCnamPortalEnabled) ||
      (includeAdmin && isAdmin())
    );
  };
};
